import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const Saving = ({ ...props }) => {
  return (
    <Svg
      width={49}
      height={48}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_818_4870)">
        <Rect x={0.278809} width={48} height={48} rx={8} fill="#F2F7FF" />
        <Path
          d="M25.56 29.088h-3.585l-1.434-11.53c2.788-.961 5.815-.961 8.603 0-1.434 5.044-2.15 7.206-3.585 11.53z"
          fill="url(#paint0_radial_818_4870)"
        />
        <Path
          d="M15.523 29.088h3.585l1.433-11.53a13.197 13.197 0 00-8.602 0c1.434 5.044 2.15 7.206 3.584 11.53z"
          fill="url(#paint1_radial_818_4870)"
        />
        <Path
          d="M23.409 25.485h-5.735l-1.434-11.53c2.788-.961 5.815-.961 8.603 0l-1.434 11.53z"
          fill="url(#paint2_radial_818_4870)"
        />
        <Path
          d="M34.879 44.581c0 7.927-6.452 7.567-14.338 7.567-7.885 0-14.337.36-14.337-7.567 0-7.927 6.452-19.096 14.337-19.096 7.886 0 14.338 11.17 14.338 19.096z"
          fill="#54A0FF"
        />
        <Path
          d="M26.276 25.34h-11.47c-.791 0-1.433.646-1.433 1.442 0 .796.642 1.441 1.433 1.441h11.47c.792 0 1.434-.645 1.434-1.441s-.642-1.441-1.434-1.441z"
          fill="url(#paint3_radial_818_4870)"
        />
        <G clipPath="url(#clip1_818_4870)">
          <Path
            d="M27.083 39.942c0 3.607-2.909 6.53-6.497 6.53a6.464 6.464 0 01-4.781-2.109 6.527 6.527 0 01-1.715-4.421c0-3.607 2.908-6.53 6.496-6.53a6.438 6.438 0 014.398 1.724 6.527 6.527 0 012.099 4.806z"
            fill="#3963A5"
          />
          <Path
            d="M23.255 38.388h-.884a2.147 2.147 0 00-.23-.558h1.114c.293 0 .53-.239.53-.533a.532.532 0 00-.53-.533h-5.011a.532.532 0 00-.53.533c0 .294.237.533.53.533h2.047c.406 0 .76.225.947.558h-2.994a.532.532 0 00-.53.533c0 .294.237.533.53.533h2.994c-.187.333-.541.558-.947.558h-2.047a.535.535 0 00-.386.899l2.884 3.077a.527.527 0 00.75.023.535.535 0 00.023-.754l-2.043-2.179h.82c1 0 1.842-.692 2.079-1.624h.884c.293 0 .53-.239.53-.533a.532.532 0 00-.53-.533z"
            fill="#fff"
          />
        </G>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.877 35.895a6.36 6.36 0 016.348-6.357 6.36 6.36 0 016.347 6.357v1.497a2.445 2.445 0 011.953 2.396v8.802a2.443 2.443 0 01-2.441 2.445H28.366a2.443 2.443 0 01-2.441-2.445v-8.802c0-1.183.838-2.17 1.952-2.396v-1.497z"
          fill="#F2F7FF"
        />
        <Path
          d="M34 31a4.881 4.881 0 00-4.875 4.875v3c0 .207.168.375.375.375H31a.375.375 0 00.375-.375v-3a2.625 2.625 0 115.25 0v3c0 .207.168.375.375.375h1.5a.375.375 0 00.375-.375v-3A4.881 4.881 0 0034 31z"
          fill="#4F4840"
        />
        <Path
          d="M29.5 38.5h9c1.035 0 1.875.84 1.875 1.875v6.75c0 1.036-.84 1.875-1.875 1.875h-9a1.875 1.875 0 01-1.875-1.875v-6.75c0-1.035.84-1.875 1.875-1.875z"
          fill="url(#paint4_radial_818_4870)"
        />
        <Path
          d="M35.875 42.625a1.875 1.875 0 10-2.707 1.673l-.29 2.025a.375.375 0 00.372.427h1.5a.375.375 0 00.375-.428l-.29-2.025a1.882 1.882 0 001.04-1.672z"
          fill="#7D613D"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_818_4870"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-2.90946 6.16532 -5.25282 -2.47885 28.137 19.175)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_818_4870"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-1.44071 5.94113 -5.05959 -1.22694 18.066 19.4)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_818_4870"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-2.90946 6.16532 -5.25282 -2.47885 23.835 15.572)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_818_4870"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 2.87538 -22.7236 0 19.723 25.387)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={0.908392} stopColor="#D1A368" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_818_4870"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(130.017 8.947 29.478) scale(11.0171 30.8347)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="clip0_818_4870">
          <Rect x={0.278809} width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
        <ClipPath id="clip1_818_4870">
          <Path
            fill="#fff"
            transform="translate(14.09 33.411)"
            d="M0 0H12.9934V13.0613H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default Saving
